// Pipeline Section (Statement of Work)
export const FETCH_SOW_DETAILS = '@@projectPQT/fetch-sow-details';
export const FETCH_SOW_DETAILS_SUCCESS = '@@projectPQT/fetch-sow-details-success';
export const FETCH_SOW_DETAILS_FAILURE = '@@projectPQT/fetch-sow-details-failure';

export const UPDATE_SOW_DETAILS = '@@projectPQT/update-sow-details';
export const UPDATE_SOW_DETAILS_FAILURE = '@@project/update-sow-details-failure';
export const SET_SOW_DETAILS_UPDATE = '@@projectPQT/set-sow-details-update';
export const DELETE_SOW_DETAILS = '@@projectPQT/delete-sow-details';
export const SET_SOW_DETAILS_DELETE = '@@project/set-sow-details-delete';

export const ADD_SOW_DETAILS = '@@projectPQT/add-sow-details';
export const ADD_SOW_DETAILS_SUCCESS = '@@projectPQT/add-sow-details-success';
export const ADD_SOW_DETAILS_FAILURE = '@@projectPQT/add-sow-details-failure';
